import { useLayoutEffect, useRef } from 'react'

const minutesToScrollPosition = (minutes: number, scale: number) =>
  Math.max(0, minutes * scale - 60 * scale)

export const useAutoscroll = (
  date: string,
  items: { position: number }[],
  scale: number
) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const scrollPositions = useRef<string[]>([])
  const prevScale = useRef(scale)

  useLayoutEffect(() => {
    const storedScrollPosition = scrollPositions.current.find(it => it === date)
    if (items.length > 0 && storedScrollPosition === undefined) {
      const newScrollInMinutes = Math.min(...items.map(it => it.position))
      scrollPositions.current = [...scrollPositions.current, date]
      scrollContainerRef.current?.scroll(
        0,
        minutesToScrollPosition(newScrollInMinutes, scale)
      )
    }
  }, [items, scale, date])

  useLayoutEffect(() => {
    if (prevScale.current !== scale) {
      const currentScrollPosition = scrollContainerRef.current?.scrollTop ?? 0
      const prevScrollInMinutes =
        (currentScrollPosition + 60 * prevScale.current) / prevScale.current
      scrollContainerRef.current?.scroll(
        0,
        minutesToScrollPosition(prevScrollInMinutes, scale)
      )
      prevScale.current = scale
    }
  }, [scale])

  return { ref: scrollContainerRef }
}
